import {
  CAISSE_CONSULT_REQUETTE,
  CAISSE_CONSULT_SUCCES,
  CAISSE_CONSULT_ECHEC,
  CAISSE_CONSLIST_REQUETTE,
  CAISSE_CONSLIST_ECHEC,
  CAISSE_CONSLIST_SUCCES,
  CAISSE_SUPP_SUCCES,
  CAISSE_SUPP_ECHEC,
  CAISSE_SUPP_REQUETTE,
} from "../constantes/caisseConstantes";

export const caisseConsultReducer = (state = { caisses: [] }, action) => {
  switch (action.type) {
    case CAISSE_CONSULT_REQUETTE:
      return {
        loading: true,
      };
    case CAISSE_CONSULT_SUCCES:
      return {
        loading: false,
        caisses: action.payload,
      };
    case CAISSE_CONSULT_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };
    default:
      return state;
  }
};
export const caisseConslistReducer = (state = { caisses: [] }, action) => {
  switch (action.type) {
    case CAISSE_CONSLIST_REQUETTE:
      return {
        loading: true,
      };
    case CAISSE_CONSLIST_SUCCES:
      return {
        loading: false,
        caisses: action.payload,
      };
    case CAISSE_CONSLIST_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };
    default:
      return state;
  }
};
export const caisseSuppReducer = (state = { msg: "" }, action) => {
  switch (action.type) {
    case CAISSE_SUPP_REQUETTE:
      return {
        loading: true,
      };
    case CAISSE_SUPP_SUCCES:
      return {
        loading: false,
        msg: action.payload,
      };
    case CAISSE_SUPP_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };
    default:
      return state;
  }
};
